import "./CheckoutPage.css";
import OrderSummaryComponent from "../../pages/Checkout/OrderSummary";
import { useState, useEffect } from "react";
import config from "../../config";
import checkout_bear from "../../images/checkout_bear.png";
import { useNavigate } from "react-router-dom";
import ShippingForm from "../Checkout/CheckoutPageComponents";
import { ShippingInfo } from "../../Interfaces/ShippingInfo";
import ShippingChoices from "../Checkout/ShippingChoices";
import { FundraiserResponse } from "../../Interfaces/Fundraiser";
import { useCart } from "../../contexts/Cart/CartContext";
import ContactForm, { ContactInfo } from "../Checkout/OrgShippingInfoForm";
import {
  SHIP_TO_CUSTOMER,
  SHIP_TO_ORG,
  SHIP_TO_PARTICIPANT,
} from "../../CommonFunctions";
const BASE_API = config.API_BASE_URL;

const CheckoutPage = () => {
  const [fundraiser, setFundraiser] = useState<FundraiserResponse | null>(null);
  const [shippingChoice, setShippingChoice] =
    useState<string>(SHIP_TO_CUSTOMER);
  const { state } = useCart();
  const navigate = useNavigate();
  const [isCheckoutEnabled, setIsCheckoutEnabled] = useState(false);
  const [freeShippingOptionSelected, setFreeShippingOptionSelected] =
    useState(false);
  const [shippingInfo, setShippingInfo] = useState<ShippingInfo>({
    ship_to_name: "",
    street_address: "",
    apt_suite: "",
    city: "",
    state: "",
    zip_code: "",
  });
  const [contactInfo, setContactInfo] = useState<ContactInfo>({
    full_name: "",
    email: "",
    phone: "",
  });
  const handleContinueShopping = () => {
    navigate("/checkout/cart"); //go back to the cart
  };
  const { freeShippingThreshold, baseShippingCost } = useCart();

  const handleShippingChoiceChange = (choice: string) => {
    setShippingChoice(choice);
    if (choice === SHIP_TO_CUSTOMER) {
      setFreeShippingOptionSelected(false);
    } else {
      setFreeShippingOptionSelected(true);
    }
  };

  // Fetch free shipping threshold from an API
  useEffect(() => {
    const fetchFundraiser = async () => {
      try {
        const response = await fetch(
          `${BASE_API}fundraiser/${state.fundraiser_participant?.fundraiser}/detailed`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch fundraiser data");
        }
        const data: FundraiserResponse = await response.json();
        setFundraiser(data);
      } catch (error) {
        console.error("Error fetching fundraiser data:", error);
      }
    };

    fetchFundraiser();

    document.title = "Checkout";
  }, []);

  if (freeShippingThreshold === null) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="checkout-page-shipping-form-and-order-summary-container">
        <div className="checkout-page-shipping-form-and-headers">
          <div className="checkout-page-header-and-image">
            <div className="checkout-page-header-text">
              <div className="checkout-page-continue-shopping">
                <span
                  onClick={handleContinueShopping}
                  className="checkout-page-continue-shopping-link"
                >
                  &lt; Back to cart
                </span>
              </div>

              <span className="checkout-page-horizontal-bar "></span>
              <div className="checkout-page-shipping-header">Checkout</div>
            </div>
            <img
              src={checkout_bear}
              alt="Bear Icon"
              className="checkout-page-checkout-image"
            />
          </div>
          <div className="checkout-page-shipping-form">
            <ContactForm
              setIsCheckoutEnabled={setIsCheckoutEnabled}
              setContactInfo={setContactInfo}
            />
          </div>
          <div className="checkout-page-shipping-form">
            <ShippingForm
              setIsCheckoutEnabled={setIsCheckoutEnabled}
              setShippingInfo={setShippingInfo}
              needShippingInfo={!freeShippingOptionSelected}
            />
          </div>
        </div>
        <div className="checkout-page-summary-shipping-container">
          {fundraiser !== null && (
            <div className="checkout-page-shipping-choices">
              <ShippingChoices
                shippingChoice={shippingChoice}
                onShippingChoiceChange={handleShippingChoiceChange}
                fundraiser={fundraiser}
              />
            </div>
          )}
          <div className="checkout-page-order-summary">
            {fundraiser !== null && (
              <OrderSummaryComponent
                freeShippingThreshold={freeShippingThreshold}
                baseShippingCost={baseShippingCost}
                isCheckoutEnabled={isCheckoutEnabled}
                setIsCheckoutEnabled={setIsCheckoutEnabled}
                onShippingStep={true}
                shippingData={shippingInfo}
                freeShippingOption={freeShippingOptionSelected}
                shippingOption={shippingChoice}
                fundraiser={fundraiser}
                contactInfo={contactInfo}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
